import readFile from './read_file'

/*
This FileUpload JS component adds the client-side interactivity to the
`YpsilonWeb.Molecules.FileUpload` component, and handles rendering a preview
image as the user adds one. In your component or page, render the elixir
component, and ensure this JS component is included on the page. See the
`Molecules/File Upload` stories for example code and variants.
*/
export default class FileUpload {
  savedFileInputFiles
  // element is an input.js-file_upload_redesign element
  constructor(element) {
    this.init(element)
  }

  init(element) {
    element.addEventListener('change', this.fileInputChanged.bind(this))
    this.getDeleteButton(element)?.addEventListener('click', this.deleteClicked.bind(this))
  }

  fileInputChanged(e) {
    const fileInput = e.target
    if (!fileInput.files[0]) {
      this.restoreSuccessfulInputFiles(fileInput)
    } else {
      readFile(fileInput, this.readFileSuccess.bind(this), this.readFileError.bind(this))
    }
  }

  readFileSuccess(fileInput, file, base64File) {
    const imageContainer = this.getImageContainer(fileInput)
    const inputContainer = this.getInputContainer(fileInput)

    this.saveSuccessfulInputFiles(fileInput)
    this.getImagePreviewElement(fileInput).src = base64File

    imageContainer.hidden = false
    inputContainer.hidden = true

    this.getDeleteImageInput(fileInput)?.removeAttribute('name')
  }

  readFileError(fileInput) {
    fileInput.value = ''
  }

  deleteClicked(e) {
    const target = e.target
    const defaultImage = this.getImagePreviewElement(target).dataset.defaultImage
    const imageContainer = this.getImageContainer(target)
    const inputContainer = this.getInputContainer(target)

    if (defaultImage) {
      this.getImagePreviewElement(target).src = defaultImage
    } else {
      this.getImagePreviewElement(target).src = ''
      imageContainer.hidden = true
      inputContainer.hidden = false
    }

    this.getFileInput(target).value = ''
    this.getDeleteImageInput(target)?.setAttribute('name', this.getDeleteImageInput(target).dataset.inputName)
    return false
  }

  saveSuccessfulInputFiles(fileInput) {
    this.savedFileInputFiles = fileInput.files
  }

  restoreSuccessfulInputFiles(fileInput) {
    fileInput.files = this.savedFileInputFiles
  }

  getWrapper(element) {
    return element.closest('.js-file_upload_container_redesign')
  }

  getInputContainer(element) {
    return this.getWrapper(element).querySelector('.js-file_upload_input_container_redesign')
  }

  getImageContainer(element) {
    return this.getWrapper(element).querySelector('.js-file_upload_preview_container_redesign')
  }

  getImagePreviewElement(element) {
    const selector = element.dataset.fileUploadPreviewContainerSelector
    if (selector) {
      return document.querySelector(selector)
    } else {
      return this.getWrapper(element).querySelector('.js-file_upload_preview_image_redesign')
    }
  }

  getDeleteButton(element) {
    return this.getWrapper(element).querySelector('.js-file_upload_delete_button_redesign')
  }

  getDeleteImageInput(element) {
    return this.getWrapper(element).querySelector('.js-file_upload_delete_image_input_redesign')
  }

  getFileInput(element) {
    return this.getWrapper(element).querySelector('.js-file_upload_redesign')
  }
}

window.up.compiler('.js-file_upload_redesign', function (element) {
  new FileUpload(element)
})
